'use strict';

var productTile = require('./../../../app_storefront_core_UI/cartridge/js/product-tile'),
	progress = require('./../../../app_storefront_core/cartridge/js/progress'),
    carousel = require('./../../../app_storefront_core_UI/cartridge/js/carousel'),
	initialized = false,
	$cache = {},
	options = {
		selectors: {
			groupedSearchResults: '.js-grouped-search-results',
			searchResultsPage: '.js-search-result-items',
			loadMoreResultsBtn: '.js-search-result-more'
		}
	};

/**
 * @private
 * @function
 * @description Initializes cache for component
 */
function initializeCache() {
	$cache.document = $(document);
}

/**
 * @private
 * @function
 * @description Initializes events for component
 */
function initializeEvents() {
	var loadMoreSelector = options.selectors.groupedSearchResults + ' ' +
		options.selectors.loadMoreResultsBtn;

	$cache.document.on('click', '.refinement .toggle', function(e) {
		$('.js-sort_by-button').removeClass('expanded');
	});

	$cache.document.on('click', loadMoreSelector, loadMoreSearchResults);
}

/**
 * Loads a new portion of grouped search results
 */
function loadMoreSearchResults(e) {
	var $loadMoreResultsBtn = $(e.target),
		$groupedSearchResult = $loadMoreResultsBtn.closest(options.selectors.groupedSearchResults),
		gridURL = null,
		currentPage = null;

	e.preventDefault();

	if (!$groupedSearchResult.length) {
		return;
	}

	gridURL = $loadMoreResultsBtn.data('grid-url') || '';
	currentPage = parseInt($loadMoreResultsBtn.data('page-number')) || 0;

	if (!gridURL.length) {
		return;
	}

	progress.show($groupedSearchResult);

	$.ajax({
		type: 'GET',
		dataType: 'html',
		url: gridURL,
		success: function (response) {
			var $response = $($.parseHTML(response)),
				$lastSearchResultPage = $groupedSearchResult.find(options.selectors.searchResultsPage).last();
			
            // update UI
			productTile.init({container: $response, start: currentPage});

			$loadMoreResultsBtn.remove();
			$lastSearchResultPage.after($response);
            carousel.init({});
			progress.hide();
			$(document).trigger("upload-products-chunk");
        }
	});
}


module.exports = {
	init : function (params) {
		if (initialized) { 
			return;
		}

		initializeCache();
		initializeEvents();

		initialized = true;
	}
}
